"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4593],{

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 4593:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
// EXTERNAL MODULE: ./src/@api/android.js
var android = __webpack_require__(19630);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./src/utils/refreshSidebarDevices.js
var utils_refreshSidebarDevices = __webpack_require__(66512);
// EXTERNAL MODULE: ./src/utils/updateDeviceCredentials.js
var utils_updateDeviceCredentials = __webpack_require__(80122);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/@core/components/modal/ios-verfiy-basic/style.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: wrap;\n\n    .ant-select .ant-select-selector {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        border: none;\n        border-radius: 26px;\n        background: #F5F6F7;\n        box-shadow: none !important;\n    }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const style_BasicVerfiyCommponents = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
/* harmony default export */ var style = ((/* unused pure expression or super */ null && (style_BasicVerfiyCommponents)));

// EXTERNAL MODULE: ./src/components/ios-extreme/icloud-locked/useIcloudLockedFlow.js + 3 modules
var icloud_locked_useIcloudLockedFlow = __webpack_require__(82000);
// EXTERNAL MODULE: ./src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify.js
var icloud_locked_useIcloudCredentialReverify = __webpack_require__(56148);
// EXTERNAL MODULE: ./src/utils/icloudLoginResult.js
var icloudLoginResult = __webpack_require__(83469);
;// CONCATENATED MODULE: ./src/@core/components/modal/ios-verfiy-basic/index.js


















const CodeBox = dynamic_default()(__webpack_require__.e(/* import() */ 7537).then(__webpack_require__.bind(__webpack_require__, 87537)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(87537)
            ]
    },
    ssr: false //这个要加上,禁止使用 SSR
});
//   基础服务 app 图标列表
const basicIcon = [
    {
        name: "Photo",
        img: "/images/dashboard/new-ios/photos.png"
    },
    {
        name: "Video",
        img: "/images/dashboard/new-ios/video.svg"
    },
    {
        name: "Locations",
        img: "/images/dashboard/new-ios/gps.png"
    },
    {
        name: "Contact",
        img: "/images/dashboard/new-ios/contacts.png"
    },
    {
        name: "Mail",
        img: "/images/dashboard/new-ios/mail.svg"
    },
    {
        name: "iCloud drive",
        img: "/images/dashboard/new-ios/icloud-drive.svg"
    },
    {
        name: "Note",
        img: "/images/dashboard/new-ios/note.png"
    },
    {
        name: "Calendar",
        img: "/images/dashboard/new-ios/calendars.svg"
    },
    {
        name: "Reminder",
        img: "/images/dashboard/new-ios/reminders.png"
    }
];
const ios_verfiy_basic_IosVerfiyBasic = ()=>{
    const dispatch = useDispatch();
    const { t  } = useTranslation("common");
    const [isModalOpen, setIsModalOpen] = useState(true) // 模态框显示状态
    ;
    const [useUserName, setUserName] = useState("") // iCloud账号
    ;
    const [usePassWord, setPassWord] = useState("") // iCloud密码
    ;
    const [showPassword, setShowPassword] = useState(false) // 密码明文/密文切换
    ;
    const [loginLoading, setLoginLoading] = useState(false) // 账号密码验证中状态
    ;
    const [modalOpen, setModalOpen] = useState(false) // 发送短信弹窗
    ;
    const [current, setCurrent] = useState(0) // 当前验证的步骤，填写账号密码 or 填写验证码
    ;
    const [innerWidth, setInnerWidth] = useState(0) // 实时屏幕宽度
    ;
    const [defaultSmsPhone, setDefaultSmsPhone] = useState({});
    const [smsId, setSmsId] = useState("");
    const [smsPhoneList, setSmsPhoneList] = useState([]);
    const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true);
    const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true);
    const [key, setKey] = useState("1");
    const [sendTime, setSentTime] = useState(60);
    const [sendContentTips, setSendContentTips] = useState("");
    const [btnDisable, setBtnDisable] = useState(false);
    const [smsErrorText, setSmsErrorText] = useState("") // icloud没有绑定手机号错误提示文案
    ;
    const onChange = async (key)=>{
        if (key == 2) {
            let check = sessionStorage.getItem("icloudPhoneSmsList");
            let result = {};
            if (check) {
                result = JSON.parse(check);
            } else {
                let mode = 1;
                result = await authInfo({
                    mode: mode,
                    username: useUserName,
                    password: usePassWord
                });
                sessionStorage.setItem("icloudPhoneSmsList", JSON.stringify(result));
            }
            setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber);
            setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || "0");
            let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map((item)=>{
                return {
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                };
            });
            setSmsPhoneList(mapData);
            setSmsPhoneListDisabled(false);
            setSmsPhoneListLoading(false);
        }
    };
    // 登录 iCloud 账号
    const login = async ()=>{
        var ref;
        if (useUserName === "" || usePassWord === "") {
            messageInfo(t("Value cannot be empty"));
            return;
        }
        let mode = 1;
        let obj = {
            mode: mode,
            username: useUserName,
            password: usePassWord,
            country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
        };
        setLoginLoading(true);
        // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
        let data;
        try {
            const res = await iosLoginVerification(obj);
            data = res === null || res === void 0 ? void 0 : res.data;
        } catch (e) {
            var ref1;
            ;
            setLoginLoading(false);
            messageInfo((e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.em) || t("Network error, please try again"));
            return;
        }
        // 上传ios日志
        iosLoginReport({
            "platform": "ios-icloud",
            "site": "msafely",
            "s_2": 1
        });
        // 无论走哪个业务分支都先关掉转圈；业务错误码在 data.ec（如 10005 Apple ID locked），
        // 顶层 code / HTTP 状态码为 0 不代表成功
        setLoginLoading(false);
        if (!data || typeof data !== "object") {
            messageInfo(t("Network error, please try again"));
            return;
        }
        if (data.ec === ICLOUD_EC.PASSWORD) {
            setLoginLoading(false);
            handlePasswordError(data.ec);
            messageInfo(data.em);
        } else if (data.ec === ICLOUD_EC.TWO_STEP) {
            var ref2;
            iosLoginReport({
                "platform": "ios-icloud",
                "site": "msafely",
                "s_3": 1
            });
            setLoginLoading(false);
            messageInfo(data.em);
            window.localStorage.setItem("DeviceUser", JSON.stringify(obj));
            setCurrent(1);
            if ((ref2 = data === null || data === void 0 ? void 0 : data.trustedPhoneNumbers[0]) === null || ref2 === void 0 ? void 0 : ref2.numberWithDialCode) {
                setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
                setSmsId(data.trustedPhoneNumbers[0].id || "0");
                let mapData = data.trustedPhoneNumbers.map((item)=>{
                    return {
                        ...item,
                        value: item.id,
                        label: item.numberWithDialCode
                    };
                });
                setSmsPhoneList(mapData);
                setSmsPhoneListDisabled(false);
            } else {
                setSmsPhoneListDisabled(true);
                if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                    setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
                } else {
                    setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
                }
            }
            setSmsPhoneListLoading(false);
        } else if (data.ec === ICLOUD_EC.LOCKED) {
            await handleEc10005({
                username: useUserName,
                password: usePassWord
            });
        } else if (isIcloudOk(data)) {
            iosLoginReport({
                "platform": "ios-icloud",
                "site": "msafely",
                "s_4": 1
            });
            setLoginLoading(false);
            messageInfo({
                content: data.em,
                duration: 8
            });
            // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
            const updateRes = await updateDeviceCredentials({
                username: useUserName,
                password: usePassWord,
                verify: 1
            });
            if (!isUpdateCredentialsOk(updateRes)) {
                messageInfo((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
                return;
            }
            window.localStorage.setItem("Basic", 1);
            window.localStorage.setItem("DeviceUser", JSON.stringify(obj));
            // 设置允许正在下载提示信息弹窗
            dispatch(changeDownloadTips(true));
            // 设置一步验证完成状态
            dispatch(changeBasicVerfiyOver(true));
            let downloadRes = await downloadWeb({
                mode: 1,
                username: useUserName,
                password: usePassWord
            });
            await sendDownloadTime({
                username: useUserName,
                type: "basic_download"
            });
            setTimeout(()=>{
                dispatch(fetchResetTime());
            }, 800);
            setIsModalOpen(false);
            refreshSidebarDevices();
        } else {
            messageInfo(data.em);
            setLoginLoading(false);
        }
    };
    // 设备验证码验证
    const codeDevice = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                let deviceUser = JSON.parse(window.localStorage.getItem("DeviceUser"));
                deviceUser.securityCode = securityCode;
                const verify = await iosLoginVerification({
                    mode: 1,
                    username: useUserName,
                    password: usePassWord,
                    securityCode: securityCode,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(verify === null || verify === void 0 ? void 0 : verify.data) || typeof verify.data !== "object") {
                    messageInfo(t("Network error, please try again"));
                    return;
                }
                if (isIcloudOk(verify.data)) {
                    iosLoginReport({
                        "platform": "ios-icloud",
                        "site": "msafely",
                        "s_4": 1
                    });
                    // 设置允许正在下载提示信息弹窗
                    dispatch(changeDownloadTips(true));
                    // 设置一步验证完成状态
                    dispatch(changeBasicVerfiyOver(true));
                    let downloadRes = await downloadWeb({
                        mode: 1,
                        username: useUserName,
                        password: usePassWord
                    });
                    // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
                    const updateRes = await updateDeviceCredentials({
                        username: useUserName,
                        password: usePassWord,
                        verify: 1
                    });
                    if (!isUpdateCredentialsOk(updateRes)) {
                        messageInfo((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again");
                        return;
                    }
                    setTimeout(async ()=>{
                        await sendDownloadTime({
                            username: useUserName,
                            type: "basic_download"
                        });
                    }, 1500);
                    setTimeout(()=>{
                        dispatch(fetchResetTime());
                    }, 2000);
                    window.localStorage.setItem("Basic", 1);
                    setIsModalOpen(false);
                    refreshSidebarDevices();
                } else {
                    handlePasswordError(verify.data.ec);
                    messageInfo(verify.data.em);
                }
            } catch (err) {
                var ref1;
                ;
                messageInfo((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || t("Network error, please try again"));
            } finally{
                setLoginLoading(false);
            }
        }
    };
    // 发送短信验证码
    const sendSms = async ()=>{
        // 已发送 / 倒计时中，避免重复点击造成重复发送
        if (btnDisable) return;
        try {
            var ref, ref1;
            const obj = await iosLoginVerification({
                mode: 1,
                username: useUserName,
                password: usePassWord,
                phoneID: smsId,
                country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
            });
            // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
            const ec = obj === null || obj === void 0 ? void 0 : (ref1 = obj.data) === null || ref1 === void 0 ? void 0 : ref1.ec;
            if (!isIcloudSendOk(ec)) {
                var ref2;
                handlePasswordError(ec);
                messageInfo((obj === null || obj === void 0 ? void 0 : (ref2 = obj.data) === null || ref2 === void 0 ? void 0 : ref2.em) || "Failed to send the verification code, please try again");
                return;
            }
            let ti = sendTime;
            const timeChange = setInterval(()=>{
                if (ti > 0) {
                    //当x>0时执行更新方法
                    ti = ti - 1;
                    setSentTime(ti);
                } else {
                    //当x=0时执行终止循环方法
                    clearInterval(timeChange);
                    setBtnDisable(false);
                    setSendContentTips("");
                    setSentTime(60);
                }
            }, 1000);
            setSentTime(60);
            setSendContentTips(t("A message containing the verification code has been sent to the target iPhone please check it"));
            setBtnDisable(true);
        } catch (e) {
            var ref3;
            ;
            setBtnDisable(false);
            setSendContentTips("");
            setSentTime(60);
            messageInfo((e === null || e === void 0 ? void 0 : (ref3 = e.data) === null || ref3 === void 0 ? void 0 : ref3.em) || "Failed to send the verification code, please try again");
        }
    };
    // 短信验证码验证
    const codeSms = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                const result = await iosLoginVerification({
                    mode: 1,
                    username: useUserName,
                    password: usePassWord,
                    securityCode: securityCode,
                    phoneID: smsId,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(result === null || result === void 0 ? void 0 : result.data) || typeof result.data !== "object") {
                    messageInfo(t("Network error, please try again"));
                    return;
                }
                if (isIcloudOk(result.data)) {
                    iosLoginReport({
                        "platform": "ios-icloud",
                        "site": "msafely",
                        "s_4": 1
                    });
                    // 设置允许正在下载提示信息弹窗
                    dispatch(changeDownloadTips(true));
                    // 设置一步验证完成状态
                    dispatch(changeBasicVerfiyOver(true));
                    let downloadRes = await downloadWeb({
                        mode: 1,
                        username: useUserName,
                        password: usePassWord
                    });
                    // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
                    const updateRes = await updateDeviceCredentials({
                        username: useUserName,
                        password: usePassWord,
                        verify: 1
                    });
                    if (!isUpdateCredentialsOk(updateRes)) {
                        messageInfo((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again");
                        return;
                    }
                    setTimeout(async ()=>{
                        await sendDownloadTime({
                            username: useUserName,
                            type: "basic_download"
                        });
                    }, 1500);
                    setTimeout(()=>{
                        dispatch(fetchResetTime());
                    }, 2000);
                    window.localStorage.setItem("Basic", 1);
                    setIsModalOpen(false);
                    refreshSidebarDevices();
                } else {
                    handlePasswordError(result.data.ec);
                    messageInfo(result.data.em);
                }
            } catch (err) {
                var ref1;
                ;
                messageInfo((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || t("Network error, please try again"));
            } finally{
                setLoginLoading(false);
            }
        }
    };
    // 处理验证码方式切换
    const handleSelectChange = (value)=>{
        setSmsId(value);
    };
    // 当发送短信弹窗显示时倒计时3秒自动关闭
    useEffect(()=>{
        if (modalOpen) {
            setTimeout(()=>{
                setModalOpen(false);
            }, 3000);
        }
    }, [
        modalOpen
    ]);
    // 发送帮助邮箱
    const sendEmail = async ()=>{
        try {
            var ref;
            //获取用户邮箱
            const email = (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.email;
            // 调用发邮件接口(code:0 成功)
            await localPhoneSendEmail({
                email
            });
            // 触发发送邮件事件
            dataLayer.push({
                event: "sned-guide-email"
            });
        } catch (e) {
            ;
        }
    };
    // 监听屏幕宽度
    useEffect(()=>{
        if (true) {
            const handlerInnerWidth = ()=>{
                setInnerWidth(window.innerWidth);
            };
            handlerInnerWidth();
            window.addEventListener("resize", handlerInnerWidth);
            return ()=>{
                window.removeEventListener("resize", handlerInnerWidth);
            };
        }
    }, []);
    const getLoginCountry = ()=>{
        var ref, ref1;
        return (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase();
    };
    const applyTwoStepVerificationState = (data, username, password)=>{
        var ref, ref1;
        messageInfo(data.em);
        window.localStorage.setItem("DeviceUser", JSON.stringify({
            mode: 1,
            username,
            password,
            country: getLoginCountry()
        }));
        setUserName(username);
        setPassWord(password);
        setCurrent(1);
        if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setKey("2");
        if (data === null || data === void 0 ? void 0 : (ref = data.trustedPhoneNumbers) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.numberWithDialCode) {
            setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
            setSmsId(data.trustedPhoneNumbers[0].id || "0");
            setSmsPhoneList(data.trustedPhoneNumbers.map((item)=>({
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                })));
            setSmsPhoneListDisabled(false);
        } else {
            setSmsPhoneListDisabled(true);
            setSmsErrorText((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0 ? t("iCloud doesnt have a phone number Please verify using the device verification code") : t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
        }
        setSmsPhoneListLoading(false);
    };
    const finishBasicDirectSuccess = async (data, username, password)=>{
        iosLoginReport({
            platform: "ios-icloud",
            site: "msafely",
            s_4: 1
        });
        messageInfo({
            content: data.em,
            duration: 8
        });
        const updateRes = await updateDeviceCredentials({
            username,
            password,
            verify: 1
        });
        if (!isUpdateCredentialsOk(updateRes)) {
            messageInfo((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
            return;
        }
        window.localStorage.setItem("Basic", 1);
        window.localStorage.setItem("DeviceUser", JSON.stringify({
            mode: 1,
            username,
            password,
            country: getLoginCountry()
        }));
        dispatch(changeDownloadTips(true));
        dispatch(changeBasicVerfiyOver(true));
        await downloadWeb({
            mode: 1,
            username,
            password
        });
        await sendDownloadTime({
            username,
            type: "basic_download"
        });
        setTimeout(()=>dispatch(fetchResetTime()), 800);
        setIsModalOpen(false);
        refreshSidebarDevices();
    };
    const { handleEc10005 , lockedFlowModals , lockedFlowOpen  } = useIcloudLockedFlow({
        mode: 1,
        updateCredentialsOnLock: true,
        onTwoStepRequired: async (param)=>{
            let { data , username , password  } = param;
            return applyTwoStepVerificationState(data, username, password);
        },
        onDirectSuccess: async (param)=>{
            let { data , username , password  } = param;
            return finishBasicDirectSuccess(data, username, password);
        }
    });
    // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
    // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
    const handlePasswordError = useIcloudCredentialReverify({
        current,
        setCurrent,
        lockedFlowOpen
    });
    return /*#__PURE__*/ _jsxs(Modal, {
        open: isModalOpen,
        onCancel: ()=>setIsModalOpen(false),
        width: 600,
        footer: null,
        centered: true,
        styles: {
            content: {
                padding: innerWidth > 768 ? "24px 24px 50px" : "24px 24px 20px",
                maxWidth: innerWidth > 768 ? "600px" : "calc(100% - 16px)",
                margin: "0 auto",
                borderRadius: "16px",
                position: "relative"
            }
        },
        zIndex: 1314,
        closeIcon: /*#__PURE__*/ _jsx(CloseOutlined, {
            style: {
                fontSize: "20px"
            }
        }) // 修改這裡的大小
        ,
        children: [
            /*#__PURE__*/ _jsxs(BasicVerfiyCommponents, {
                className: "min-h-[546px] Mlg:h-auto Mlg:min-h-[505px]",
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        src: "/images/apps/apple.svg",
                        alt: "img",
                        className: "w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px] mt-[26px] Mlg:mt-[23px]",
                        width: "60",
                        height: "69"
                    }),
                    current === 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "max-w-[484px] mt-[30px] Mlg:mt-[24px] mb-[36px] Mlg:mb-[20px] text-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]",
                                children: t("Enter the iCloud account and password of the monitored iPhone")
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "w-[340px] Mlg:w-full flex flex-col items-center",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "w-full flex flex-col",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mb-[5px] text-[14px] text-[#334062] leading-[21px] lg:hidden",
                                                children: t("Apple ID")
                                            }),
                                            /*#__PURE__*/ _jsx(Input, {
                                                className: "w-full h-[48px] Mlg:h-[40px] !bg-[rgba(244,245,246,0.92)] border-none focus:[box-shadow:0px_0px_0px_1px_#12D8AB] placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[30px] px-[20px] smj:px-4 text-[14px] Mlg:text-[12px]",
                                                style: {
                                                    outline: "none"
                                                },
                                                onChange: (e)=>setUserName(e.target.value.trim()),
                                                placeholder: t("Apple ID")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "w-full flex flex-col mt-[24px] Mlg:mt-[10px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mb-[5px] text-[14px] text-[#334062] leading-[21px] lg:hidden",
                                                children: t("Password")
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "relative w-full",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Input, {
                                                        className: "w-full h-[48px] Mlg:h-[40px] !bg-[rgba(244,245,246,0.92)] border-none focus:[box-shadow:0px_0px_0px_1px_#12D8AB] placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[30px] px-[20px] pr-[45px] smj:px-4 smj:pr-[45px] text-[14px] Mlg:text-[12px]",
                                                        type: showPassword ? "text" : "password",
                                                        value: usePassWord,
                                                        onChange: (e)=>setPassWord(e.target.value.trim()),
                                                        placeholder: t("Password")
                                                    }),
                                                    /*#__PURE__*/ _jsx(Image, {
                                                        src: showPassword ? "/extreme/open.svg" : "/extreme/close.svg",
                                                        width: 18,
                                                        height: 18,
                                                        alt: "",
                                                        className: "absolute top-0 bottom-0 my-auto right-[15px] cursor-pointer Mlg:w-[15px] Mlg:h-[15px]",
                                                        onClick: ()=>setShowPassword(!showPassword)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "w-full my-[24px] flex items-start justify-center text-[14px] Mlg:text-[10px] text-[#F11E34] leading-[21px] Mlg:leading-[15px] p-[8px_12px_7px_4px] Mlg:p-[14px_17px_11px] bg-[rgba(255,0,0,0.05)] rounded-[6px]",
                                        children: [
                                            /*#__PURE__*/ _jsx(Image, {
                                                src: "/images/apps/waring.svg",
                                                className: "flex items-start mt-[5px] Mlg:mt-[1px] Mlg:mr-[7px]",
                                                alt: "img",
                                                width: 12,
                                                height: 12
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "text-center",
                                                children: t("A two-step verification code or SMS will be sent to the target iPhone from Apple official")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "w-full flex justify-center items-center",
                                        children: /*#__PURE__*/ _jsxs("button", {
                                            className: "".concat(loginLoading ? "opacity-70" : "", " w-[fit-content] mx-auto py-[10px] px-[70px] text-[18px] leading-[28px] bg-[#50E3C2] text-[#1B1C2B] font-[700] rounded-[6px] flex justify-center items-center"),
                                            onClick: ()=>{
                                                if (loginLoading) return;
                                                login();
                                            },
                                            children: [
                                                t("Connect"),
                                                loginLoading && /*#__PURE__*/ _jsx("div", {
                                                    className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#50E3C2] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-[14px] text-[#12D8AB] text-center font-[400] leading-[22px] mt-[16px] Mlg:mt-[15px] cursor-pointer",
                                onClick: ()=>{
                                    sendEmail();
                                    setModalOpen(true);
                                },
                                children: t("How to get the required conditions")
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "w-max max-w-[90%] absolute top-[50%] left-[50%] flex items-center justify-center ".concat(!modalOpen ? "hidden" : "", " z-[5254]"),
                                onClick: ()=>setModalOpen(false),
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "w-full max-w-[420px] xs:max-w-[360px] transform -translate-x-1/2 -translate-y-1/2 bg-black shadow-4xl rounded-[12px]",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "p-[22px_19px_27px_16px] flex flex-col items-start justify-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "w-full text-[16px] text-white font-[Roboto] font-[400] leading-[24px] text-left",
                                                children: t("A guidance email has been sent to your mailbox")
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "w-full text-[16px] text-white font-[Roboto] font-[400] leading-[24px] text-left mt-[5px]",
                                                children: t("If not received it please check in spam or click again")
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "max-w-[484px] mt-[32px] Mlg:mt-[24px] text-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]",
                                children: t("Choose a verification method")
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "w-[310px] Mlg:w-full",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "w-full h-[27px] flex items-center my-[26px] Mlg:mt-[31px] Mlg:mb-[30px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "".concat(key == "1" ? "text-[16px] text-[#50E3C2] border-b-[#50E3C2]" : "text-[16px] text-[#000] border-b-[#FFF]", " h-[27px] border-b-[2px] flex items-center cursor-pointer"),
                                                onClick: ()=>{
                                                    if (key == "1") return;
                                                    setKey("1");
                                                },
                                                children: t("Device")
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "".concat(key == "2" ? "text-[16px] text-[#50E3C2] border-b-[#50E3C2]" : "text-[16px] text-[#000] border-b-[#FFF]", " ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer"),
                                                onClick: ()=>{
                                                    if (key == "2") return;
                                                    if (smsPhoneListDisabled) {
                                                        messageInfo(smsErrorText);
                                                    } else {
                                                        setKey("2");
                                                    }
                                                },
                                                children: t("SMS")
                                            })
                                        ]
                                    }),
                                    key == "1" && /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Spin, {
                                                spinning: loginLoading,
                                                children: /*#__PURE__*/ _jsx(CodeBox, {
                                                    length: 6,
                                                    inputType: "numeric" // 输入框输入类型
                                                    ,
                                                    size: innerWidth > 768 ? 45 : 42,
                                                    gap: innerWidth > 768 ? 8 : 9,
                                                    styles: {
                                                        background: "#F5F6F7",
                                                        borderRadius: "8px",
                                                        color: "#494949",
                                                        fontFamily: "Roboto",
                                                        fontSize: "26px"
                                                    },
                                                    onChange: codeDevice
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "mt-[24px] text-center text-[12px] text-[#9A9A9E] leading-[18px]",
                                                children: t("A verification code has been sent to the target iPhone Enter the verification code")
                                            })
                                        ]
                                    }),
                                    key == "2" && /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        defaultValue: defaultSmsPhone,
                                                        style: {
                                                            flex: 1,
                                                            height: "100%"
                                                        },
                                                        suffixIcon: smsPhoneListLoading ? /*#__PURE__*/ _jsx("div", {
                                                            className: "w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]"
                                                        }) : /*#__PURE__*/ _jsx(Image, {
                                                            className: "mr-[5px]",
                                                            src: "/images/user-verify/dropdown.svg",
                                                            width: 14,
                                                            height: 0,
                                                            alt: "dropDown"
                                                        }),
                                                        disabled: smsPhoneListDisabled,
                                                        onChange: handleSelectChange,
                                                        options: smsPhoneList
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        disabled: btnDisable,
                                                        className: "w-full max-w-max min-w-[85px] h-full flex justify-center items-center",
                                                        style: {
                                                            opacity: btnDisable ? 0.7 : 1,
                                                            background: "#50E3C2",
                                                            padding: "0px 21px",
                                                            marginLeft: "10px",
                                                            color: "#1B1C2B",
                                                            borderRadius: "41px",
                                                            fontSize: "18px"
                                                        },
                                                        onClick: sendSms,
                                                        children: btnDisable ? sendTime : t("Send")
                                                    })
                                                ]
                                            }),
                                            sendContentTips != "" && /*#__PURE__*/ _jsxs("p", {
                                                className: "text-center mb-[24px] text-[12px] text-[#9A9A9E] leading-[18px]",
                                                children: [
                                                    " ",
                                                    sendContentTips
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Spin, {
                                                spinning: loginLoading,
                                                children: /*#__PURE__*/ _jsx(CodeBox, {
                                                    length: 6,
                                                    inputType: "numeric" // 输入框输入类型
                                                    ,
                                                    size: innerWidth > 768 ? 45 : 42,
                                                    gap: innerWidth > 768 ? 8 : 9,
                                                    styles: {
                                                        background: "#F5F6F7",
                                                        borderRadius: "8px",
                                                        color: "#494949",
                                                        fontFamily: "Roboto",
                                                        fontSize: "26px"
                                                    },
                                                    onChange: codeSms
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "mt-[24px] text-center text-[12px] text-[#9A9A9E] leading-[18px]",
                                                children: t("Enter the verification code")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            lockedFlowModals
        ]
    });
};
/* harmony default export */ var ios_verfiy_basic = ((/* unused pure expression or super */ null && (ios_verfiy_basic_IosVerfiyBasic)));

;// CONCATENATED MODULE: ./src/@core/components/modal/ios-verfiy-extreme/style.js

function style_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: wrap;\n\n    .ant-select .ant-select-selector {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        border: none;\n        border-radius: 26px;\n        background: #F5F6F7;\n        box-shadow: none !important;\n    }\n"
    ]);
    style_templateObject = function() {
        return data;
    };
    return data;
}

const style_IosVerfiyExtremeCommponents = styled_components_browser_esm/* default.div */.ZP.div(style_templateObject());
/* harmony default export */ var ios_verfiy_extreme_style = ((/* unused pure expression or super */ null && (style_IosVerfiyExtremeCommponents)));

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/@core/components/modal/ios-verfiy-extreme/index.js

















const ios_verfiy_extreme_CodeBox = dynamic_default()(__webpack_require__.e(/* import() */ 7537).then(__webpack_require__.bind(__webpack_require__, 87537)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(87537)
            ]
    },
    ssr: false //这个要加上,禁止使用 SSR
});
//增值服务服务 app 图标列表
const extremeIcon = [
    {
        name: "Text message",
        img: "/images/dashboard/new-ios/imessagers.svg"
    },
    {
        name: "Call",
        img: "/images/dashboard/new-ios/calls.svg"
    },
    {
        name: "Voicemail",
        img: "/images/dashboard/new-ios/voicemail.svg"
    },
    {
        name: "WhatsApp",
        img: "/images/dashboard/new-ios/whatsapp.svg"
    },
    {
        name: "WA Business",
        img: "/images/dashboard/new-ios/whatappbusiness.svg"
    },
    {
        name: "Line",
        img: "/images/dashboard/new-ios/line.svg"
    },
    {
        name: "Kik",
        img: "/images/dashboard/new-ios/kik.svg"
    },
    {
        name: "WeChat",
        img: "/images/dashboard/new-ios/wechat.svg"
    },
    {
        name: "Messenger",
        img: "/images/dashboard/new-ios/facebookmessage.svg"
    },
    {
        name: "Browser history",
        img: "/images/dashboard/new-ios/browsing.png"
    },
    {
        name: "Browser Bookmark",
        img: "/images/dashboard/new-ios/bookmark.png"
    },
    {
        name: "Install Apps",
        img: "/images/dashboard/new-ios/installapp.png"
    },
    {
        name: "Wi-Fi network",
        img: "/images/dashboard/new-ios/wifi.png"
    },
    {
        name: "Skype",
        img: "/images/dashboard/new-ios/skype.svg"
    },
    {
        name: "Teams",
        img: "/images/dashboard/new-ios/teams.png"
    },
    {
        name: "Telegram",
        img: "/images/dashboard/new-ios/telegram.svg"
    },
    {
        name: "Snapchat",
        img: "/images/dashboard/new-ios/snapchat.svg"
    },
    {
        name: "Instagram",
        img: "/images/dashboard/new-ios/instagram.svg"
    },
    {
        name: "Facetime",
        img: "/images/dashboard/new-ios/facetime.svg"
    }
];
const ios_verfiy_extreme_IosVerfiyExtreme = (param)=>{
    let { setBackupOpen  } = param;
    const dispatch = useDispatch();
    const { t  } = useTranslation("common");
    const [isModalOpen, setIsModalOpen] = useState(false) // 模态框显示状态
    ;
    const [loginLoading, setLoginLoading] = useState(false) // 验证中状态
    ;
    const [current, setCurrent] = useState(0) // 当前验证的步骤，发送验证码 or 填写验证码
    ;
    const [innerWidth, setInnerWidth] = useState(0) // 实时屏幕宽度
    ;
    const [defaultSmsPhone, setDefaultSmsPhone] = useState({});
    const [smsPhoneList, setSmsPhoneList] = useState([]);
    const [smsPhoneListLoading, setSmsPhoneListLoading] = useState(true);
    const [smsPhoneListDisabled, setSmsPhoneListDisabled] = useState(true);
    const [smsId, setSmsId] = useState("");
    const [key, setKey] = useState("1");
    const [sendTime, setSentTime] = useState(60);
    const [sendContentTips, setSendContentTips] = useState("");
    const [btnDisable, setBtnDisable] = useState(false);
    const [smsErrorText, setSmsErrorText] = useState("") // icloud没有绑定手机号错误提示文案
    ;
    let user = JSON.parse(localStorage.getItem("DeviceUser")) // 获取浏览器缓存中的用户信息
    ;
    const persistUserCredentials = (username, password)=>{
        const deviceUser = JSON.parse(localStorage.getItem("DeviceUser")) || {};
        user = {
            ...deviceUser,
            username,
            password
        };
        window.localStorage.setItem("DeviceUser", JSON.stringify(user));
    };
    const applyExtremeTwoStepVerification = (data, username, password)=>{
        var ref, ref1;
        persistUserCredentials(username, password);
        messageInfo(data.em);
        setCurrent(1);
        if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setKey("2");
        if (data === null || data === void 0 ? void 0 : (ref = data.trustedPhoneNumbers) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.numberWithDialCode) {
            setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
            setSmsId(data.trustedPhoneNumbers[0].id || "0");
            setSmsPhoneList(data.trustedPhoneNumbers.map((item)=>({
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                })));
            setSmsPhoneListDisabled(false);
        } else {
            setSmsPhoneListDisabled(true);
            setSmsErrorText((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0 ? t("iCloud doesnt have a phone number Please verify using the device verification code") : t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
        }
        setSmsPhoneListLoading(false);
    };
    const finishExtremeDirectSuccess = async (data, username, password)=>{
        persistUserCredentials(username, password);
        messageInfo(data.em);
        const updateRes = await updateDeviceCredentials({
            username,
            password,
            verify: 1
        });
        if (!isUpdateCredentialsOk(updateRes)) {
            messageInfo((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
            return;
        }
        window.localStorage.setItem("Advanced", 1);
        dispatch(changeDownloadTips(true));
        dispatch(changeBasicVerfiyOver(false));
        await downloadWeb({
            mode: 2,
            username,
            password
        });
        await sendDownloadTime({
            username,
            type: "advanced_download"
        });
        setTimeout(()=>dispatch(fetchResetTime()), 800);
        setIsModalOpen(false);
        if (typeof setBackupOpen === "function") setBackupOpen(true);
    };
    const { handleEc10005 , lockedFlowModals , lockedFlowOpen  } = useIcloudLockedFlow({
        mode: 2,
        updateCredentialsOnLock: true,
        onTwoStepRequired: async (param)=>{
            let { data , username , password  } = param;
            return applyExtremeTwoStepVerification(data, username, password);
        },
        onDirectSuccess: async (param)=>{
            let { data , username , password  } = param;
            return finishExtremeDirectSuccess(data, username, password);
        }
    });
    // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
    // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
    const handlePasswordError = useIcloudCredentialReverify({
        current,
        setCurrent,
        lockedFlowOpen
    });
    const onChange = async (key)=>{
        if (key == 2) {
            let check = sessionStorage.getItem("icloudPhoneSmsList");
            let result = {};
            if (check) {
                result = JSON.parse(check);
            } else {
                let mode = 1;
                result = await authInfo({
                    mode: mode,
                    username: user.username,
                    password: user.password
                });
                sessionStorage.setItem("icloudPhoneSmsList", JSON.stringify(result));
            }
            setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber);
            setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || "0");
            let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map((item)=>{
                return {
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                };
            });
            setSmsPhoneList(mapData);
            setSmsPhoneListDisabled(false);
            setSmsPhoneListLoading(false);
        }
    };
    // 发送设备码
    const sendCode = async ()=>{
        setLoginLoading(true);
        // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
        let data;
        try {
            var ref;
            const res = await iosLoginVerification({
                mode: 2,
                username: user.username,
                password: user.password,
                country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
            });
            data = res === null || res === void 0 ? void 0 : res.data;
        } catch (e) {
            var ref1;
            ;
            setLoginLoading(false);
            messageInfo((e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.em) || "Network error, please try again");
            return;
        }
        setLoginLoading(false);
        // 业务错误码在 data.ec（如 10005 Apple ID locked）；顶层 code / HTTP 状态码为 0 不代表成功
        if (!data || typeof data !== "object") {
            messageInfo("Network error, please try again");
            return;
        }
        if (data.ec === ICLOUD_EC.PASSWORD) {
            handlePasswordError(data.ec);
            messageInfo(data.em);
            setLoginLoading(false);
        } else if (data.ec === ICLOUD_EC.TWO_STEP) {
            var ref2;
            setLoginLoading(false);
            messageInfo(data.em);
            setCurrent(1);
            if ((ref2 = data === null || data === void 0 ? void 0 : data.trustedPhoneNumbers[0]) === null || ref2 === void 0 ? void 0 : ref2.numberWithDialCode) {
                setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
                setSmsId(data.trustedPhoneNumbers[0].id || "0");
                let mapData = data.trustedPhoneNumbers.map((item)=>{
                    return {
                        ...item,
                        value: item.id,
                        label: item.numberWithDialCode
                    };
                });
                setSmsPhoneList(mapData);
                setSmsPhoneListDisabled(false);
            } else {
                setSmsPhoneListDisabled(true);
                if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                    setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
                } else {
                    setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
                }
            }
            setSmsPhoneListLoading(false);
        } else if (data.ec === ICLOUD_EC.LOCKED) {
            await handleEc10005({
                username: user.username,
                password: user.password
            });
        } else if (isIcloudOk(data)) {
            setLoginLoading(false);
            messageInfo(data.em);
            // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
            const updateRes = await updateDeviceCredentials({
                username: user.username,
                password: user.password,
                verify: 1
            });
            if (!isUpdateCredentialsOk(updateRes)) {
                messageInfo((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
                return;
            }
            window.localStorage.setItem("Advanced", 1);
            // 设置允许正在下载提示信息弹窗
            dispatch(changeDownloadTips(true));
            // 设置一步验证结束状态
            dispatch(changeBasicVerfiyOver(false));
            let downloadRes = await downloadWeb({
                mode: 2,
                username: user.username,
                password: user.password
            });
            await sendDownloadTime({
                username: user.username,
                type: "advanced_download"
            });
            setTimeout(()=>{
                dispatch(fetchResetTime());
            }, 800);
            modalOnCancel();
        } else {
            messageInfo(data.em);
        }
    };
    // 验证设备码
    const codeDevice = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                let deviceUser = JSON.parse(window.localStorage.getItem("DeviceUser"));
                deviceUser.securityCode = securityCode;
                // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
                const updateRes = await updateDeviceCredentials({
                    username: user.username,
                    password: user.password,
                    verify: 1
                });
                if (!isUpdateCredentialsOk(updateRes)) {
                    messageInfo((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again");
                    return;
                }
                window.localStorage.setItem("Advanced", 1);
                const verify = await iosLoginVerification({
                    mode: 2,
                    username: user.username,
                    password: user.password,
                    securityCode: securityCode,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(verify === null || verify === void 0 ? void 0 : verify.data) || typeof verify.data !== "object") {
                    messageInfo(t("Network error, please try again"));
                    return;
                }
                if (isIcloudOk(verify.data)) {
                    // 设置允许正在下载提示信息弹窗
                    dispatch(changeDownloadTips(true));
                    // 设置一步验证结束状态
                    dispatch(changeBasicVerfiyOver(false));
                    let downloadRes = await downloadWeb({
                        mode: 2,
                        username: user.username,
                        password: user.password
                    });
                    await sendDownloadTime({
                        username: user.username,
                        type: "advanced_download"
                    });
                    setTimeout(()=>{
                        dispatch(fetchResetTime());
                    }, 800);
                    modalOnCancel();
                } else {
                    handlePasswordError(verify.data.ec);
                    messageInfo(verify.data.em);
                }
            } catch (err) {
                var ref1;
                ;
                messageInfo((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || t("Network error, please try again"));
            } finally{
                setLoginLoading(false);
            }
        }
    };
    // 手机号列表选择更改
    const handleSelectChange = (value)=>{
        setSmsId(value);
    };
    // 发送短信验证码
    const sendSms = async ()=>{
        // 已发送 / 倒计时中，避免重复点击造成重复发送
        if (btnDisable) return;
        try {
            var ref, ref1;
            const result = await iosLoginVerification({
                mode: 2,
                username: user.username,
                password: user.password,
                phoneID: smsId,
                country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
            });
            // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
            const ec = result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.ec;
            if (!isIcloudSendOk(ec)) {
                var ref2;
                handlePasswordError(ec);
                messageInfo((result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.em) || "Failed to send the verification code, please try again");
                return;
            }
            let ti = sendTime;
            const timeChange = setInterval(()=>{
                if (ti > 0) {
                    //当x>0时执行更新方法
                    ti = ti - 1;
                    setSentTime(ti);
                } else {
                    //当x=0时执行终止循环方法
                    clearInterval(timeChange);
                    setBtnDisable(false);
                    setSendContentTips("");
                    setSentTime(60);
                }
            }, 1000);
            setSentTime(60);
            setSendContentTips("SMS has been sent, please receive");
            setBtnDisable(true);
        } catch (e) {
            var ref3;
            ;
            setBtnDisable(false);
            setSendContentTips("");
            setSentTime(60);
            messageInfo((e === null || e === void 0 ? void 0 : (ref3 = e.data) === null || ref3 === void 0 ? void 0 : ref3.em) || "Failed to send the verification code, please try again");
        }
    };
    // 验证短信验证码
    const codeSms = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                const result = await iosLoginVerification({
                    mode: 2,
                    username: user.username,
                    password: user.password,
                    securityCode: securityCode,
                    phoneID: smsId,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(result === null || result === void 0 ? void 0 : result.data) || typeof result.data !== "object") {
                    messageInfo(t("Network error, please try again"));
                    return;
                }
                if (isIcloudOk(result.data)) {
                    // 设置允许正在下载提示信息弹窗
                    dispatch(changeDownloadTips(true));
                    // 设置一步验证结束状态
                    dispatch(changeBasicVerfiyOver(false));
                    let downloadRes = await downloadWeb({
                        mode: 2,
                        username: user.username,
                        password: user.password
                    });
                    await sendDownloadTime({
                        username: user.username,
                        type: "advanced_download"
                    });
                    setTimeout(()=>{
                        dispatch(fetchResetTime());
                    }, 800);
                    window.localStorage.setItem("Advanced", 1);
                    modalOnCancel();
                } else {
                    handlePasswordError(result.data.ec);
                    messageInfo(result.data.em);
                }
            } catch (err) {
                var ref1;
                ;
                messageInfo((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || t("Network error, please try again"));
            } finally{
                setLoginLoading(false);
            }
        }
    };
    // 监听屏幕宽度
    useEffect(()=>{
        if (true) {
            const handlerInnerWidth = ()=>{
                setInnerWidth(window.innerWidth);
            };
            handlerInnerWidth();
            window.addEventListener("resize", handlerInnerWidth);
            return ()=>{
                window.removeEventListener("resize", handlerInnerWidth);
            };
        }
    }, []);
    // 模态框关闭事件
    const modalOnCancel = ()=>{
        setIsModalOpen(false);
        localStorage.setItem("isIosVerfiyExtremeOpen", "false");
        if (typeof setBackupOpen === "function") setBackupOpen(true);
    };
    const router = useRouter();
    useEffect(()=>{
        if (false) {}
        const isIosVerfiyExtremeOpen = localStorage.getItem("isIosVerfiyExtremeOpen") !== "false";
        if (!isIosVerfiyExtremeOpen && router.pathname !== "/dashboard") {
            setIsModalOpen(false);
        } else {
            setIsModalOpen(true);
        }
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ _jsxs(Modal, {
        open: isModalOpen,
        onCancel: modalOnCancel,
        width: 600,
        footer: null,
        centered: true,
        styles: {
            content: {
                padding: innerWidth > 768 ? "24px 30px 50px 26px" : "24px 24px 50px",
                maxWidth: innerWidth > 768 ? "600px" : "calc(100% - 16px)",
                margin: "0 auto",
                borderRadius: "16px",
                position: "relative"
            }
        },
        zIndex: 1314,
        closeIcon: /*#__PURE__*/ _jsx(CloseOutlined, {
            style: {
                fontSize: innerWidth > 768 ? "20px" : "18px"
            }
        }) // 修改這裡的大小
        ,
        children: [
            /*#__PURE__*/ _jsxs(IosVerfiyExtremeCommponents, {
                className: "min-h-[546px] Mlg:h-auto Mlg:min-h-[505px]",
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        src: "/images/apps/apple.svg",
                        alt: "img",
                        className: "w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px] mt-[26px] Mlg:mt-[23px] ".concat(current != 0 ? "Mlg:hidden" : ""),
                        width: "60",
                        height: "69"
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "my-[24px] Mlg:mb-[30px] text-[24px] Mlg:text-[20px] text-[#282938] text-center font-[600] leading-[40px] Mlg:leading-[30px] ".concat(current != 0 ? "Mlg:hidden" : ""),
                        children: [
                            "Extreme",
                            " ",
                            t("Data Validation")
                        ]
                    }),
                    current == 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("ul", {
                                className: "grid grid-cols-10 Mlg:grid-cols-6 gap-[16px]",
                                children: extremeIcon.map((item, index)=>/*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(Image, {
                                            src: item.img,
                                            alt: item.name,
                                            className: "w-[40px] h-[40px] object-cover p-[2px] rounded-[8px] bg-[#F0F1F5]",
                                            width: "40",
                                            height: "40"
                                        })
                                    }, index))
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "w-full max-w-[484px] Mlg:max-w-[253px] mt-[48px] Mlg:mt-[16px] mb-[32px] Mlg:mb-[24px] text-[20px] Mlg:text-[14px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[21px]",
                                children: [
                                    t("Access to"),
                                    " ",
                                    "extreme",
                                    " ",
                                    t("data requires re-verification now is the best time to do so")
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                className: "".concat(loginLoading ? "opacity-70" : "", " w-max min-w-[279px] max-w-full h-[47px] px-[21px] bg-[#50E3C2] text-[#1B1C2B] text-[18px] font-[700] rounded-[6px] flex justify-center items-center"),
                                onClick: ()=>{
                                    if (loginLoading) return;
                                    sendCode();
                                },
                                children: [
                                    t("Send Code Again"),
                                    loginLoading && /*#__PURE__*/ _jsx("div", {
                                        className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#50E3C2] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("hr", {
                                className: "w-[480px] h-[1.5px] Mlg:w-full bg-[#9A9A9E] mt-[32px] Mlg:mt-[24px] mb-[16px]"
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "text-[14px] text-[#000000] leading-[22px]",
                                children: [
                                    "*",
                                    t("Youve obtained all basic data")
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs("p", {
                                className: "mt-[23px] mb-[24px] text-[20px] text-[#282938] text-center font-[600] leading-[30px] lg:hidden",
                                children: [
                                    "Extreme",
                                    " ",
                                    t("Data Validation")
                                ]
                            }),
                            /*#__PURE__*/ _jsx("hr", {
                                className: "w-full bg-[#DADADA] absolute top-[101px] lg:hidden"
                            }),
                            /*#__PURE__*/ _jsx(Image, {
                                src: "/images/apps/apple.svg",
                                alt: "img",
                                className: "w-[35px] h-[40px] my-[20px] lg:hidden",
                                width: "60",
                                height: "69"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "max-w-[484px] text-[20px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]",
                                children: t("Choose a verification method")
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "w-[310px] Mlg:w-full",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "w-full h-[27px] flex items-center my-[26px] Mlg:mt-[18px] Mlg:mb-[30px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "".concat(key == "1" ? "text-[16px] text-[#50E3C2] border-b-[#50E3C2]" : "text-[16px] text-[#000] border-b-[#FFF]", " h-[27px] border-b-[2px] flex items-center cursor-pointer"),
                                                onClick: ()=>{
                                                    if (key == "1") return;
                                                    setKey("1");
                                                },
                                                children: t("Device")
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "".concat(key == "2" ? "text-[16px] text-[#50E3C2] border-b-[#50E3C2]" : "text-[16px] text-[#000] border-b-[#FFF]", " ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer"),
                                                onClick: ()=>{
                                                    if (key == "2") return;
                                                    if (smsPhoneListDisabled) {
                                                        messageInfo(smsErrorText);
                                                    } else {
                                                        setKey("2");
                                                    }
                                                },
                                                children: t("SMS")
                                            })
                                        ]
                                    }),
                                    key == "1" && /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Spin, {
                                                spinning: loginLoading,
                                                children: /*#__PURE__*/ _jsx(ios_verfiy_extreme_CodeBox, {
                                                    length: 6,
                                                    inputType: "numeric" // 输入框输入类型
                                                    ,
                                                    size: innerWidth > 768 ? 45 : 42,
                                                    gap: innerWidth > 768 ? 8 : 9,
                                                    styles: {
                                                        background: "#F5F6F7",
                                                        borderRadius: "8px",
                                                        color: "#494949",
                                                        fontFamily: "Roboto",
                                                        fontSize: "26px"
                                                    },
                                                    onChange: codeDevice
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                                children: t("A verification code has been sent to the target iPhone Enter the verification code")
                                            })
                                        ]
                                    }),
                                    key == "2" && /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Select, {
                                                        defaultValue: defaultSmsPhone,
                                                        style: {
                                                            flex: 1,
                                                            height: "100%"
                                                        },
                                                        suffixIcon: smsPhoneListLoading ? /*#__PURE__*/ _jsx("div", {
                                                            className: "w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]"
                                                        }) : /*#__PURE__*/ _jsx(Image, {
                                                            className: "mr-[5px]",
                                                            src: "/images/user-verify/dropdown.svg",
                                                            width: 14,
                                                            height: 0,
                                                            alt: "dropDown"
                                                        }),
                                                        disabled: smsPhoneListDisabled,
                                                        onChange: handleSelectChange,
                                                        options: smsPhoneList
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        disabled: btnDisable,
                                                        className: "w-full max-w-max min-w-[85px] h-full flex justify-center items-center",
                                                        style: {
                                                            opacity: btnDisable ? 0.7 : 1,
                                                            background: "#50E3C2",
                                                            padding: "0px 21px",
                                                            marginLeft: "10px",
                                                            color: "#1B1C2B",
                                                            borderRadius: "41px",
                                                            fontSize: "18px"
                                                        },
                                                        onClick: sendSms,
                                                        children: btnDisable ? sendTime : t("Send")
                                                    })
                                                ]
                                            }),
                                            sendContentTips != "" && /*#__PURE__*/ _jsxs("p", {
                                                className: "text-center mb-[24px] text-[12px] text-[#9A9A9E]",
                                                children: [
                                                    " ",
                                                    sendContentTips
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Spin, {
                                                spinning: loginLoading,
                                                children: /*#__PURE__*/ _jsx(ios_verfiy_extreme_CodeBox, {
                                                    length: 6,
                                                    inputType: "numeric" // 输入框输入类型
                                                    ,
                                                    size: innerWidth > 768 ? 45 : 42,
                                                    gap: innerWidth > 768 ? 8 : 9,
                                                    styles: {
                                                        background: "#F5F6F7",
                                                        borderRadius: "8px",
                                                        color: "#494949",
                                                        fontFamily: "Roboto",
                                                        fontSize: "26px"
                                                    },
                                                    onChange: codeSms
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                                children: t("Enter the verification code")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            lockedFlowModals
        ]
    });
};
/* harmony default export */ var ios_verfiy_extreme = ((/* unused pure expression or super */ null && (ios_verfiy_extreme_IosVerfiyExtreme)));

// EXTERNAL MODULE: ./src/@core/components/modal/ios-backup/index.js
var ios_backup = __webpack_require__(6493);
;// CONCATENATED MODULE: ./src/@core/components/ios-verfiy-process/index.js








const IosVerfiyProcess = ()=>{
    let Basic = window.localStorage.getItem("Basic");
    Basic = Basic == null || Basic == 0 ? true : false;
    const router = useRouter();
    const store = useSelector((state)=>state.Common);
    const basicOver = [
        true,
        "true"
    ].includes(store.basicVerfiyOver) // 是否已完成一步验证
    ;
    const resetTimePending = isResetTimePending(store.resetTime) // 首屏数据未就绪时不判
    ;
    // 与 SpyX 对齐：看「高级验证是否触发过」(advancedDownloadTime)，而非「高级数据是否下载完成」
    const basicNotOver = isBasicStepStillRequired(store.resetTime);
    const advancedNotOver = isAdvancedVerificationIncomplete(store.resetTime);
    const downloadTips = [
        true,
        "true"
    ].includes(store.downloadTips) // 是否显示下载提示
    ;
    const [isModalOpen, setIsModalOpen] = useState(false) // 备份提示模态框显示状态
    ;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            Basic && /*#__PURE__*/ _jsx(IosVerfiyBasic, {}),
            !resetTimePending && (basicOver || !basicNotOver && advancedNotOver) && /*#__PURE__*/ _jsx(IosVerfiyExtreme, {
                setBackupOpen: setIsModalOpen
            }),
            downloadTips && /*#__PURE__*/ _jsx(IosBackup, {
                isModalOpen: isModalOpen,
                setIsModalOpen: setIsModalOpen
            })
        ]
    });
};
/* harmony default export */ var ios_verfiy_process = ((/* unused pure expression or super */ null && (IosVerfiyProcess)));


/***/ }),

/***/ 6493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61906);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(60770);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97937);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2261);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66832);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4839);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24576);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89995);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29143);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34745);














// 备份提示步骤集合
const backupArr = [
    {
        url: "/images/ios-backup/step1.webp",
        alt: "backup-step1",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Open the Settings of the target device and click on the account name"
    },
    {
        url: "/images/ios-backup/step2.webp",
        alt: "backup-step2",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Tap iCloud"
    },
    {
        url: "/images/ios-backup/step3.webp",
        alt: "backup-step3",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Select iCloud Backup"
    },
    {
        url: "/images/ios-backup/step4.webp",
        alt: "backup-step4",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Tap the slider next to iCloud Backup If its green youll know youve turned on iCloud backup and you can skip to the next step"
    },
    {
        url: "/images/ios-backup/step5.webp",
        alt: "backup-step5",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Make sure to enable syncing for all the apps you want to monitor"
    },
    {
        url: "/images/ios-backup/step6.webp",
        alt: "backup-step6",
        width: "371px",
        height: "379px",
        mbWidth: "325px",
        mbHeight: "332px",
        text: "Finally click Back Up Now Wait until the backup process complete While your iPhone is backing up your data You must remain connected to Wi-Fi"
    },
    {
        url: "/images/ios-backup/step7.webp",
        alt: "backup-step7",
        width: "421px",
        height: "379px",
        mbWidth: "325px",
        mbHeight: "293px",
        text: "Make sure there is enough storage left in the target iCloud account When the iCloud is full you can only see the previous backup data if you wanna view more data you can consider upgrading the iCloud storage plan"
    },
    {
        url: "/images/ios-backup/step8.png",
        alt: "backup-step8",
        width: "180px",
        height: "379px",
        mbWidth: "180px",
        mbHeight: "379px",
        text: "Turn on the Access iCloud Data on Web toggle"
    }
];
const IosBackup = (param)=>{
    let { isModalOpen , setIsModalOpen , type =0  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const store = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)((state)=>state.Common);
    const [current, setCurrent] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 当前的步骤
    ;
    const swiperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const prevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 上一步按钮
    ;
    const nextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 下一步按钮
    ;
    const paginationRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 圆点导航按钮
    ;
    const [innerWidth, setInnerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 实时屏幕宽度
    ;
    const downloadTips = [
        true,
        "true"
    ].includes(store.downloadTips) // 显示下载提示弹窗
    ;
    // 监听屏幕宽度
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (true) {
            const handlerInnerWidth = ()=>{
                setInnerWidth(window.innerWidth);
            };
            handlerInnerWidth();
            window.addEventListener("resize", handlerInnerWidth);
            return ()=>{
                window.removeEventListener("resize", handlerInnerWidth);
            };
        }
    }, []);
    // 模态框关闭事件
    const modalOnCancel = ()=>{
        setIsModalOpen(false);
        // 是完成验证时关闭弹窗弹窗下载提示信息
        if (type == 0 && downloadTips) {
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_10__/* .messageInfo */ .B)({
                content: t("Please wait patiently for the data to download If the data is still not updated after half an hour it is likely that the target device has not enabled backup"),
                duration: 10
            });
            // 清除允许弹窗状态
            dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_11__/* .changeDownloadTips */ .em)(false));
        }
    };
    // 每次打开弹窗重置到步骤一
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isModalOpen && swiperRef.current) {
            swiperRef.current.slideTo(0);
            setCurrent(0);
        }
    }, [
        isModalOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        open: isModalOpen,
        onCancel: modalOnCancel,
        maskClosable: innerWidth > 768,
        width: 600,
        footer: null,
        centered: true,
        styles: {
            content: {
                padding: innerWidth > 768 ? "50px 50px 19px" : "40px 10px 8px",
                borderRadius: "16px",
                position: "relative"
            }
        },
        zIndex: 1314,
        closeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
            style: {
                fontSize: innerWidth > 768 ? "20px" : "18px"
            }
        }) // 修改這裡的大小
        ,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col items-center min-h-[671px] Mlg:h-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/images/apps/apple.svg",
                    alt: "img",
                    className: "w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]",
                    width: "60",
                    height: "69"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "mt-[24px] text-[30px] Mlg:text-[20px] text-[#2405F2] text-center font-[600] leading-[40px] Mlg:leading-[30px]",
                    children: t("Turn on the iCloud Backup")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-max max-w-full my-[16px] flex items-start justify-center text-[14px] Mlg:text-[10px] text-[#F11E34] leading-[21px] Mlg:leading-[15px] p-[8px_20px_8px_16px] Mlg:p-[14px_17px_11px] bg-[#FF00000D] rounded-[6px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/images/apps/waring.svg",
                            className: "flex items-start mt-[5px] Mlg:mt-[3px] mr-[8px]",
                            alt: "img",
                            width: 12,
                            height: 12
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-center",
                            children: t("You can only get all data if iCloud is turned on")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
                    allowTouchMove: innerWidth <= 768,
                    onSwiper: (swiper)=>{
                        swiperRef.current = swiper;
                    },
                    modules: [
                        swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Navigation */ .W_,
                        swiper_modules__WEBPACK_IMPORTED_MODULE_6__/* .Pagination */ .tl
                    ],
                    direction: "horizontal",
                    navigation: {
                        prevEl: prevRef.current,
                        nextEl: nextRef.current
                    },
                    onBeforeInit: (swiper)=>{
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                        swiper.params.pagination.el = paginationRef.current;
                        swiper.params.pagination.renderBullet = (_, className)=>'<div class="'.concat(className, ' myBullet"></div>');
                    },
                    pagination: {
                        clickable: true,
                        el: paginationRef.current,
                        renderBullet: (_, className)=>{
                            return '<div class="'.concat(className, ' myBullet"></div>');
                        }
                    },
                    onSlideChange: (e)=>setCurrent(e.realIndex),
                    className: "w-full relative",
                    children: [
                        backupArr.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                                className: "h-full flex flex-col justify-center items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "h-[379px] mb-[24px] Mlg:mb-[48px]",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: item.url,
                                            alt: item.alt,
                                            width: 100,
                                            height: 100,
                                            style: {
                                                width: innerWidth > 768 ? item.width : item.mbWidth,
                                                height: innerWidth > 768 ? item.height : item.mbHeight
                                            },
                                            className: "object-cover object-left-top [box-shadow:0px_4px_18px_0px_#00000033] select-none"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "w-full text-[14px] text-[#000000] text-center leading-[22px]",
                                        children: t(item.text)
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full Mlg:hidden absolute top-[40%] -translate-y-[50%] z-20 select-none",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    ref: prevRef,
                                    className: "banner_prev absolute left-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/images/ios-backup/arrow-left.svg",
                                        alt: "arrow-left",
                                        width: 24,
                                        height: 24,
                                        className: "w-[24px] h-[24px] ".concat(current === 0 ? "opacity-0 pointer-events-none" : "opacity-100 cursor-pointer")
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    ref: nextRef,
                                    className: "banner_next absolute right-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: "/images/ios-backup/arrow-right.svg",
                                        alt: "arrow-right",
                                        width: 24,
                                        height: 24,
                                        className: "w-[24px] h-[24px] ".concat(current === backupArr.length - 1 ? "opacity-0 pointer-events-none" : "opacity-100 cursor-pointer")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: paginationRef,
                            className: "!h-[8px] flex justify-center items-center gap-x-[5px] absolute !top-[403px] !left-[50%] !-translate-x-[50%] z-20 lg:hidden"
                        })
                    ]
                }, innerWidth <= 768 ? "mobile" : "desktop")
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IosBackup);


/***/ }),

/***/ 66512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ii": function() { return /* binding */ refreshSidebarDevices; },
/* harmony export */   "MD": function() { return /* binding */ SIDEBAR_DEVICES_REFRESH_EVENT; }
/* harmony export */ });
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);

/** 侧栏设备 / 未绑订单刷新事件（Equipment / AndroidEquipment 监听） */ const SIDEBAR_DEVICES_REFRESH_EVENT = "sidebarDevicesRefresh";
/**
 * 绑定完成后刷新侧栏：
 * 1. 重拉 getAllUserDevice 写入 allDeviceUser
 * 2. 广播事件，驱动侧栏再请求设备列表 + getNotBindOrder
 */ const refreshSidebarDevices = async ()=>{
    if (false) {}
    try {
        const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
        localStorage.setItem("allDeviceUser", JSON.stringify(Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : []));
    } catch (e) {
        ;
    }
    window.dispatchEvent(new CustomEvent(SIDEBAR_DEVICES_REFRESH_EVENT));
    return {
        ok: true
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (refreshSidebarDevices)));


/***/ })

}]);